import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { History as HistoryIcon } from '@mui/icons-material';

interface VersionBadgeProps {
  currentVersionNumber: number;
  totalVersionCount?: number;
  versionLabel?: string;
  onClick?: () => void;
  isPublisher?: boolean;
}

const VersionBadge: React.FC<VersionBadgeProps> = ({
  currentVersionNumber,
  totalVersionCount,
  versionLabel,
  onClick,
  isPublisher = false,
}) => {
  // Publishers always see the badge (even for unversioned content, so they can start versioning).
  // Non-publishers only see it once the content has been explicitly updated (v2+).
  if (!isPublisher && (!currentVersionNumber || currentVersionNumber <= 1)) return null;
  if (isPublisher && currentVersionNumber == null) return null;

  // Unversioned legacy content (currentVersionNumber = 0) displays as "v1"
  const effectiveVersion = currentVersionNumber > 0 ? currentVersionNumber : 1;
  const label = versionLabel || `v${effectiveVersion}`;
  const tooltip = isPublisher && totalVersionCount
    ? `Version ${effectiveVersion} of ${totalVersionCount}. Click to manage versions.`
    : currentVersionNumber > 0
      ? `Version ${effectiveVersion}. Click to view version history.`
      : 'Click to manage version history.';

  return (
    <Tooltip title={tooltip}>
      <Chip
        icon={<HistoryIcon />}
        label={label}
        size="small"
        variant="outlined"
        color="primary"
        onClick={onClick}
        clickable={!!onClick}
        sx={{ ml: 1, cursor: onClick ? 'pointer' : 'default' }}
      />
    </Tooltip>
  );
};

export default VersionBadge;
